import {injectable} from 'inversify';

export interface IParagraphObject {
	title: string;
	text: string;
}

@injectable()
export class Translator {
	protected _locale: string;
	protected _localeStrings: any;
	protected _englishLocale: object;

	constructor() {}

	init(locale: string): void {
		this.locale = locale;
	}

	public getObject(id: string, ...subIds: string[]): string {
		if (this.localeObjects && this.localeObjects[id]) {
			if (subIds.length > 0) {
				const reducedStrings = subIds.reduce((result, item) => {
					if (!result || !result[item]) {
						if (!__PRODUCTION__) {
							console.warn(`MISSING TRANSLATION / STRING FOR "${item}".`);
						}

						return this.getEnglishObject(id, ...subIds);
					}

					return result[item];
				}, this.localeObjects[id]);

				return this.flattenString(reducedStrings);
			}

			return this.flattenString(this.localeObjects[id]);
		}

		return this.getEnglishObject(id, ...subIds);
	}

	public getEnglishObject(id: string, ...subIds: string[]): string {
		if (this._englishLocale && this._englishLocale[id]) {
			if (subIds.length > 0) {
				const reducedStrings = subIds.reduce((result, item) => {
					if (!result || !result[item]) {
						return '';
					}

					return result[item];
				}, this._englishLocale[id]);

				return this.flattenString(reducedStrings);
			}

			return this.flattenString(this._englishLocale[id]);
		}

		return '';
	}

	protected flattenString(stringObject: string | string[]): string {
		if (Array.isArray(stringObject)) {
			const flattenedObject = stringObject.join(' ');

			return flattenedObject;
		} else {
			return stringObject;
		}
	}

	public set locale(value: string) {
		this._locale = value;
	}

	public get locale(): string {
		return this._locale;
	}

	public set localeObjects(value: any) {
		this._localeStrings = value;
	}

	public get localeObjects(): any {
		return this._localeStrings;
	}

	public set englishObject(value: any) {
		this._englishLocale = value;
	}

	public get englishObject(): any {
		return this._englishLocale;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/paytable/Translator.ts